








































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import FileUpload from '@/components/FileUpload.vue';
import DocPreviewDialog from '@/components/DocPreviewDialog.vue';
import { api } from '@/api';

@Component({
  components: {
    FileUpload,
    DocPreviewDialog
  }
})
export default class FileField extends Mixins(CommonMixin) {
  // Props
  @Prop(String) public readonly label!: string;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop(String) public readonly apiParentUrl!: string;
  @Prop({ type: String, default: '' }) public accept!: string;
  @Prop({ type: String, default: '2' }) public readonly labelCols!: string;
  @Prop({ type: String, default: '6' }) public readonly inputCols!: string;
  @Prop({ type: String, default: '2' }) public readonly iconCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  // @Prop(Boolean) public isEditable!: boolean;
  // @Prop(Boolean) public isNew!: boolean;
  public dialogDelete = false;
  public dialogUpload = false;
  public apiFileUrl() { return this.apiParentUrl + '/' + this.field; }

  public previewFile() {
    const ref: any = this.$refs.docpreview;
    ref.open(this.apiFileUrl());
  }
  public downloadFile() {
    api.downloadFile(this.$store, this.apiFileUrl());
  }
  public async deleteFile() {
    await api.deleteRecord(this.$store, this.apiFileUrl());
    this.$set(this.rec, this.field, null);
  }
  public async handleUploadedFile(frec) {
    this.$set(this.rec, this.field, frec);
    // this.rec[this.field] = frec.name;
    this.dialogUpload = false;
  }
}
